import React from "react";
import apexAdapter from "../adapters/ApexAdapter";
import { SampleApexAdapter } from "../adapters/ApexAdapter";

// const namespace: any = process.env.REACT_APP_SFDC_NAMESPACE;
declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    jsforce: any,
    baseUrl: string
}
const useApexAdapter = (params: any, justData = false) => {
    const [state, setState] = React.useState({
        loading: false,
        callApi: true,
    });
    let [data, setData] = React.useState<any>({
        response: null
    });
    function getData(){
        let headers = {};
        let method = 'GET';
        let route = '/v1/sobject';
        setAdapterState({
            loading: true,
            callApi: false
        });
        apexAdapter(method, route, {}, params, headers, (result: any, event: any) =>{
            let data = JSON.parse(result);
            
            const newState = {
                loading: false,
                callApi: false,
            };
            setAdapterState(newState);
            setData(data);
        });
    }

    React.useEffect(() => {
        if(!state.callApi){
            return;
        }
        getData();
    });

    if(justData){
        return [data];
    }
    function setAdapterState(newState: any){
        newState = {
            ...state,
            ...newState
        };
        setState(newState);
    }
    return [ state.loading, data, state, setAdapterState ];
}

const useSampleAdapter = (params: any, justData = false) => {
    const [state, setState] = React.useState({
        loading: false,
        callApi: true,
    });
    let [data, setData] = React.useState<any>({
        response: null
    });
    function getData(){
        let headers = {};
        let method = 'GET';
        let route = '/v1/sobject';
        setAdapterState({
            loading: true,
            callApi: false
        });
        SampleApexAdapter(method, route, {}, params, headers, (result: any, event: any) =>{
            let data = JSON.parse(result);
            
            const newState = {
                loading: false,
                callApi: false,
            };
            setAdapterState(newState);
            setData(data);
        });
    }

    React.useEffect(() => {
        if(!state.callApi){
            return;
        }
        getData();
    });

    if(justData){
        return [data];
    }
    function setAdapterState(newState: any){
        newState = {
            ...state,
            ...newState
        };
        setState(newState);
    }
    return [ state.loading, data, state, setAdapterState ];
}
function getNamespace(namespace = ""){
    const configuredNamespace = process.env.REACT_APP_SFDC_NAMESPACE;
    if(configuredNamespace && configuredNamespace.length > 0){
        namespace = configuredNamespace;
    }
    if(typeof(window.inlineApexAdaptor) === 'undefined' || typeof(window.inlineApexAdaptor) !== "object" || !window.inlineApexAdaptor.hasOwnProperty("controller")){
        return namespace;
    }
    const namespaceArray = window.inlineApexAdaptor.controller.split(".");
    if(namespaceArray.length > 1){
        namespace = namespaceArray[0];
    }
    return namespace;
}
function translateNamespace(data: any, namespace: string = null){
    if(namespace === null){
        namespace = getNamespace();
        if(namespace && namespace.length > 0){
            namespace = namespace+"__";
        }
    }
    let newData: any = {};
    if(typeof(data) === "object"){
        if(Array.isArray(data)){
            newData = [];
            data.map((item) => {
                newData.push(translateNamespace(item));
                return null;
            });
        }else{
            newData = {};
            for(var key in data){
                const newKey = key.replace(namespace, "");
                if(!data[key]){
                    newData[newKey] = data[key];
                }else{
                    newData[newKey] = translateNamespace(data[key]);
                }
            }
        }
        return newData;
    }    
    return data;
}

export { useApexAdapter, translateNamespace, useSampleAdapter, getNamespace };

export default useApexAdapter;